import { restore, sample } from 'effector'
import { fx } from '../../../../../libs'
import { $generateBalanceFilter } from '../generalBalanceFilter/model'
import { PassiveBalancesData, RDCBalancesResponse } from './types'
import {
  $passiveBalanceFilter,
  setPassiveBalanceFilter,
} from '../passiveBalanceFilter/model'

export const getPassiveBalances = fx<void, PassiveBalancesData | null>({
  method: 'GET',
  url: `/finance/balance-summary-passive`,
})

export const getRDCBalances = fx<void, RDCBalancesResponse | null>({
  method: 'GET',
  url: `/finance/rdc`,
})

export const $passiveBalances = restore<PassiveBalancesData | null>(
  getPassiveBalances.doneData.map((a) => a.body),
  null,
)

export const $RDCBalances = restore<RDCBalancesResponse | null>(
  getRDCBalances.doneData.map((a) => a.body),
  null,
)

const applyDateFilter = (
  requestObj: Record<string, unknown>,
  date: { dateFrom?: string; dateTo?: string },
) => {
  if (!date.dateFrom && !date.dateTo) {
    const currentDate = new Date()
    requestObj['dateFrom'] = `${currentDate.getFullYear()}-${
      currentDate.getMonth() + 1
    }-01`
    requestObj['dateTo'] = `${currentDate.getFullYear()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getDate()}`
  }
  if (date.dateFrom) {
    requestObj['dateFrom'] = date.dateFrom
  }
  if (date.dateTo) {
    requestObj['dateTo'] = date.dateTo
  }
}

sample({
  // @ts-ignore
  clock: setPassiveBalanceFilter,
  source: {
    generateBalanceFilter: $generateBalanceFilter,
    passiveBalanceFilter: $passiveBalanceFilter,
  },
  fn: ({ generateBalanceFilter, passiveBalanceFilter }) => {
    const { date } = generateBalanceFilter
    const { passiveBalanceCountries, product } = passiveBalanceFilter

    const query = {}
    const requestObj: any = {}

    applyDateFilter(requestObj, date)
    if (passiveBalanceCountries.length > 0) {
      requestObj['country'] = passiveBalanceCountries
    }
    if (product) {
      requestObj['product'] = product
    }

    //@ts-ignore
    query['where'] = `${JSON.stringify(requestObj)}`

    return {
      query,
    }
  },
  target: getPassiveBalances,
})

sample({
  // @ts-ignore
  clock: setPassiveBalanceFilter,
  source: {
    generateBalanceFilter: $generateBalanceFilter,
  },
  fn: ({ generateBalanceFilter }) => {
    const { date } = generateBalanceFilter

    const query = {}
    const requestObj: any = {}

    applyDateFilter(requestObj, date)

    //@ts-ignore
    query['where'] = `${JSON.stringify(requestObj)}`

    return {
      query,
    }
  },
  target: getRDCBalances,
})
